import api from './api';

export const getUsers = ({ page = 1, search = '', role = '', sortBy = '', sortOrder = '' } = {}) =>
  api.get(`/api/v1/users?page=${page}&search=${search}&role=${role}&sortBy=${sortBy}&sortOrder=${sortOrder}`);
export const getUser = (id) => api.get(`/api/v1/users/${id}`);
export const updateUser = (id, payload) => api.patch(`/api/v1/users/${id}`, payload);
export const deleteUser = (id) => api.delete(`/api/v1/users/${id}`);
export const getMyProfile = () => api.get('/api/v1/users/me');
export const updateMyProfile = (payload) => api.patch('/api/v1/users/me', payload);
